module.exports = __webpack_public_path__ + "static/Recommendations-0f151995c366dcc3ff2a47fe7d2de096.webp";